import { newsletterApi } from './newsletter.api';

export const newsletterActions = {
  async getNewsletters({ commit }, payload) {
    try {
      commit('GET_NEWSLETTERS_LOADING');
      const response = await newsletterApi.getNewsletters(payload);
      commit('GET_NEWSLETTERS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_NEWSLETTERS_ERROR', error.response);
    }
  },
  async getNewsletter({ commit }, id) {
    try {
      commit('GET_NEWSLETTER_LOADING');
      const response = await newsletterApi.getNewsletter(id);
      commit('GET_NEWSLETTER_SUCCESS', response.data);
    } catch (error) {
      commit('GET_NEWSLETTER_ERROR', error.response);
    }
  },
  async addNewsletter({ commit }, body) {
    try {
      commit('ADD_NEWSLETTER_LOADING');
      const response = await newsletterApi.addNewsletter(body);
      commit('ADD_NEWSLETTER_SUCCESS', response.data);
    } catch (error) {
      commit('ADD_NEWSLETTER_ERROR', error.response);
    }
  },
  async deleteNewsletter({ commit }, id) {
    try {
      commit('DELETE_NEWSLETTER_LOADING');
      const response = await newsletterApi.deleteNewsletter(id);
      commit('DELETE_NEWSLETTER_SUCCESS', response.data);
    } catch (error) {
      commit('DELETE_NEWSLETTER_ERROR', error.response);
    }
  },
  async updateNewsletter({ commit }, { id, body }) {
    try {
      commit('UPDATE_NEWSLETTER_LOADING');
      const response = await newsletterApi.updateNewsletter(id, body);
      commit('UPDATE_NEWSLETTER_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_NEWSLETTER_ERROR', error.response);
    }
  },
};
